import { IAccountMappingSubFLI, IAccountMappingTemplateGroupItemFLI } from '@modeso/types__aumico-lib-annualreport-be';

export interface IRemoveAccountEvent {
    item: IAccountMappingTemplateGroupItemFLI | IAccountMappingSubFLI;
    accountTopGroupName: string;
}
